import { load } from "@fingerprintjs/botd";
import { memoize } from "lodash";

/**
 * 根据UA判断是否是爬虫
 */
export function isSpiderClient(ua?: string) {
  if (!ua && (typeof window === "undefined" || !navigator?.userAgent)) {
    return false;
  }

  const spiderIndicators = ["spider", "Spider", "bot", "Bot"];
  const userAgent = ua || navigator.userAgent;

  return spiderIndicators.some((indicator) => userAgent.includes(indicator));
}

/**
 * 使用fingerprintjs/botd库检测是否是机器人或爬虫
 * 返回值为boolean，true表示是机器人或爬虫，false表示不是
 */
async function isBotdFn() {
  // Get detection results when you need them.
  try {
    // Initialize an agent at application startup, once per page/app.
    const botd = await load();
    const result = botd.detect();
    return result?.bot;
  } catch (error) {
    return console.error(error);
  }
}

/**
 * 使用fingerprintjs/botd库检测是否是机器人或爬虫
 * 返回值为boolean，true表示是机器人或爬虫，false表示不是
 * 通过memorizeFn缓存，避免重复检测，提高性能
 */
export const isBotd = memoize(isBotdFn);
